import React from "react"
import GetInTouchImg from "../images/get-in-touch-img.png"
import { FaLinkedin, FaFacebook, FaInstagram } from "react-icons/fa"

const GetInTouch = () => {
  return (
    <section className="bg-primary text-white container mx-auto xl:w-3/5 px-6 pt-12">
      <div className="flex flex-col md:flex-row items-center pb-12">
        <div className="w-full md:w-2/3 pb-8">
          <h2 className="text-5xl font-light leading-tight pb-8 text-center lg:text-left">
            <span className="block font-semibold">Opportunities</span> don't
            happen, you create them.
          </h2>
          <p className="text-center lg:text-left pb-8">
            We want to know more about you!. Write to us at
            <a href="mailto:hello@avalith.net">hello@avalith.net</a> or leave us
            your information and we will get in touch!
          </p>
          <form
            action="https://formspree.io/f/mleozdew"
            method="POST"
            className="mb-8"
          >
            <input
              type="text"
              name="nombres"
              id="nombres"
              className="flex-1 px-4 py-2 block rounded-full outline-none focus:outline-none text-primary w-full md:w-2/3 mb-8"
              placeholder="nombres"
              required
            />

            <input
              type="email"
              name="e-mail"
              id="e-mail"
              className="flex-1 px-4 py-2 block rounded-full outline-none focus:outline-none text-primary w-full md:w-2/3 mb-8"
              placeholder="e-mail"
              required
            />

            <textarea
              id="mensaje"
              name="mensaje"
              className="flex-1 px-4 py-2 block rounded-xl outline-none focus:outline-none text-primary w-full md:w-2/3 mb-8"
              placeholder="tu mensaje"
              rows="5"
              required
            />

            <button
              className="border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn ml-16"
              type="submit"
            >
              Send it
            </button>
          </form>
        </div>
        <figure className="hidden md:block w-full md:w-1/3 pb-8">
          <img src={GetInTouchImg} alt="Get In Touch" className="mx-auto" />
        </figure>
      </div>

      <div className="flex flex-col items-center">
        <div className="w-full">
          <h2 className="text-white font-bold text-4xl">Our Homes</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-8">
            <div>
              <h5 className="text-2xl mb-4 font-medium">Argentina</h5>
              <p>Olavarría 2660, C.P.: B7600FXR, Mar del Plata, Buenos Aires</p>
            </div>
            <div>
              <h5 className="text-2xl mb-4 font-medium">United States</h5>
              <p>470 Ansin Blvd Ste K, Hallandale Beach, Florida, 33009</p>
            </div>
            <div>
              <h5 className="text-2xl mb-4 font-medium">Ecuador</h5>
              <p>Calle 3 S/N, Ayampe,Manabi, 130315</p>
            </div>
          </div>
        </div>
        <div className="py-3 flex">
          <a
            href="https://www.linkedin.com/company/avalith-net"
            title="Avalith in Linkedin"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin className="text-4xl bg-secondary hover:text-white mx-4 text-primary rounded-full p-2 w-10 h-10 transition duration-500 ease-in-out" />
          </a>
          <a
            href="https://www.facebook.com/avalith.net"
            title="Avalith in Facebook"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebook className="text-4xl bg-secondary hover:text-white mx-4 text-primary rounded-full p-2 w-10 h-10 transition duration-500 ease-in-out" />
          </a>
          <a
            href="https://www.instagram.com/avalithar"
            title="Avalith in Instagram"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram className="text-4xl bg-secondary hover:text-white mx-4 text-primary rounded-full p-2 w-10 h-10 transition duration-500 ease-in-out" />
          </a>        
        </div>
      </div>
    </section>
  )
}
export default GetInTouch
